import { NgStyle } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-placeholder-picture',
  standalone: true,
  imports: [NgStyle],
  templateUrl: './placeholder-picture.component.html',
  styleUrl: './placeholder-picture.component.scss'
})
export class PlaceholderPictureComponent {
  colour = input('grey');
  isGuardian = input(false);
  size = input(48);
}
